import { EditContext } from '@efdigital/ll-admin-v2/components/edit-context.gts';
import { EditMailout } from '@efdigital/ll-admin-v2/components/programs/messages/edit-mailout.gts';
import { EditMessage } from '@efdigital/ll-admin-v2/components/programs/messages/edit-message.gts';
import MessagesList from '@efdigital/ll-admin-v2/components/programs/messages/messages-list.gts';
import ScheduleBreadcrumb from '@efdigital/ll-admin-v2/components/programs/schedule-breadcrumb.gts';
import type { ProgramsProgramCohortScheduleAnnouncementModel } from '@efdigital/ll-admin-v2/routes/programs/program/cohort/schedule/announcement';
import { type TemplateOnlyComponent } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { pageTitle } from 'ember-page-title';

interface Signature {
  Args: {
    model: ProgramsProgramCohortScheduleAnnouncementModel;
  };
}

const ProgramsProgramCohortScheduleAnnouncementTemplate: TemplateOnlyComponent<Signature> =
  <template>
    {{pageTitle "Announcement"}}
    <ScheduleBreadcrumb @model={{@model}} />

    <div class="container py-4">
      <EditContext as |context|>
        <div class="row">
          <div class="col-xl-6">
            <EditMessage
              @item={{@model.message}}
              @programId={{@model.program_id}}
              @cohortId={{@model.cohort_id}}
              @showContent={{true}}
              @showCalendarItems={{false}}
              @context={{context}}
            />
          </div>
          <div class="col-xl-6">
            <h3 class="gud-eyebrow">Preview</h3>
            <MessagesList
              @messages={{array @model.message}}
              @category="announcement"
              @programId={{@model.program_id}}
              @cohortId={{@model.cohort_id}}
            />
            <hr class="my-4" />
            <EditMessage
              @item={{@model.message}}
              @programId={{@model.program_id}}
              @cohortId={{@model.cohort_id}}
              @showContent={{false}}
              @showCalendarItems={{true}}
              @context={{context}}
            />
            <hr class="my-4" />
            <EditMailout @message={{@model.message}} class="mt-4" />
          </div>
        </div>
      </EditContext>
    </div>
  </template>;

export default ProgramsProgramCohortScheduleAnnouncementTemplate;
